/**
 * POINT_ESTABLISHED (craps) — pure transitional beat between a
 * come-out point roll and the first POINT_ROLL.
 *
 * No UI of its own. The "Point is N" copy was previously an
 * instruction-banner reveal here AFTER the dice flyout, which
 * effectively duplicated the label that already rode on the come-out
 * dice flyout (CRAPS_POINT_SET → "Point is 6" / "Mark the 6" /
 * "Working the 6"). Showing it twice plus the server-side pre+main
 * timers added ~5s of dead time before the shooter could throw again.
 *
 * Server-side timer is now near-instant (TIMERS.pointEstablishedMain ~
 * 200ms, no preTimer) so this state lives long enough only to break
 * the same-state COME_OUT → POINT_ROLL transition. Dice cleared by the
 * post-roll chain in ComeOutState.onExit; new dice spawn for POINT_ROLL.
 */

import { State } from '../State.js';

export class PointEstablishedState extends State {
  // No onEnter, onUpdate, or onExit. Pure transitional state.
}
